<!--退款列表-->
<template>
	<div class="flex-box">
		<div class="search-box">
			<div v-if="$hasPermission('A10501')">
				<label style="width: auto;" class="searchItemName">渠道：</label>
				<el-select v-model="SelectChannelId" clearable placeholder="筛选渠道">
					<el-option v-for="item in options" :key="item.id" :label="item.channelName" :value="item.id">
					</el-option>
				</el-select>
			</div>

			<div>
				<label class="searchItemName">设备号：</label>
				<el-input class="input-box" placeholder="设备号" v-model="queryParams.deviceCode" clearable>
				</el-input>
			</div>

			<div>
				<label class="searchItemName">缴费者姓名：</label>
				<el-input class="input-box" placeholder="缴费者姓名" v-model="queryParams.idName" clearable>
				</el-input>
			</div>

			<div>
				<label class="searchItemName">日期：</label>
				<el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
				</el-date-picker>
			</div>

			<el-button style="margin-left: 10px;" type="primary" v-on:click="GetData()"
				icon="el-icon-search">查询</el-button>
			<el-button style="margin-left: 10px;" type="primary" v-on:click="ExportTable()"
				icon="el-icon-download">退款记录信息下载</el-button>
		</div>
		<!--数据表格-->
		<div>
			<el-table :data="tableData" border style="width: 100%;margin: 15px 0px;">
				<el-table-column prop="id" label="id" width="auto" min-width="110" align="center">
				</el-table-column>
				<el-table-column prop="orderId" label="订单号" width="auto" min-width="160" align="center">
				</el-table-column>
				<el-table-column prop="operaterName" label="退款操作人" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="reason" label="退款原因" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="refundTime" label="退款时间" width="auto" min-width="120" align="center">
				</el-table-column>
				<el-table-column prop="orderNumber" label="业务编号" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="refundAmount" label="退款金额" width="auto" min-width="100" align="center">
					<template slot-scope="scope">
						{{scope.row.refundAmount/100}}元
					</template>
				</el-table-column>
				<el-table-column prop="idName" label="付款人姓名" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="payTime" label="付款时间" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="refundType" label="退款业务类型" width="auto" min-width="120" align="center">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.refundType === 1 ? 'danger' : (scope.row.refundType === 2 ?'warning':(scope.row.refundType === 3 ?'primary':'info'))"
							disable-transitions>{{scope.row.refundType === 1 ? '全部' : (scope.row.refundType === 2 ?'体检':(scope.row.refundType === 3 ?'拍照':'未知类型'))}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="tradeNumber" label="支付平台订单号" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="channelName" label="渠道名" width="auto" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="deviceCode" label="设备编号" width="auto" min-width="100" align="center">
				</el-table-column>
			</el-table>
		</div>
		<div>
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
				:page-size="queryParams.pageSize" layout="sizes, prev, pager, next" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import XLSX from 'xlsx';
	import {
		post
	} from '../../../../public/request/request.js';
	export default {
		data() {
			return {
				/**
				 * 数据总条数
				 */
				total: 0,
				/**
				 * 接口查询参数
				 */
				queryParams: {
					/**
					 * 当前页码
					 */
					pageIndex: 1,
					/**
					 * 每页条数
					 */
					pageSize: 10,
					/**
					 * 渠道id
					 */
					channelId: 0,
					beginTime: '',
					endTime: '',
					deviceCode: '',
					idName: ''
				},
				/**
				 * 渠道下拉框
				 */
				options: [],
				/**
				 * 数据表格
				 */
				tableData: [],
			}
		},
		/**
		 * 方法
		 */
		methods: {
			/**
			 * 获取数据列表
			 */
			GetData() {
				const loading = this.openLoading();
				// 获取退款记录列表
				post('410', this.queryParams)
					.then(response => {
						if (response.data.result == 0) {
							this.tableData = response.data.data.list;
							this.total = response.data.data.pageCount * this.queryParams.pageSize;
							loading.close();
						} else {
							this.$message.error('查询数据失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '查询数据失败');
					});
			},
			/**
			 * 导出表格
			 */
			ExportTable() {
				// 创建工作簿
				/* const wb = XLSX.utils.book_new();
				// 创建工作表数据
				const ws = XLSX.utils.json_to_sheet([{
						A1: "数据1",
						B1: "数据2"
					},
					{
						A2: "数据3",
						B2: "数据4"
					}
				]);
				// 将工作表添加到工作簿
				XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); */


				//此处的this.tableData为列表的数据集合
				const data = this.tableData.map(item => {
					return {
						'id': item.id,
						'orderId': item.orderId,
						'退款操作人': item.operaterName,
						'退款原因': item.reason,
						'退款时间':item.refundTime,
						'业务编号':item.orderNumber,
						'退款金额':item.refundAmount/100,
						'付款人姓名':item.idName,
						'付款时间':item.payTime,
						'退款业务类型':item.refundType === 1 ? '全部' : (item.refundType === 2 ?'体检':(item.refundType === 3 ?'拍照':'未知类型')),
						'支付平台订单号':item.tradeNumber,
						'渠道名称':item.channelName,
						'设备编号':item.deviceCode
					};
				});
				const worksheet = XLSX.utils.json_to_sheet(data);
				const columnWidths = [{wch: 10}, // 第一列宽度为20
					{wch: 15}, // 第二列宽度为15
					{wch: 10}, // 第三列宽度为10
					{wch: 15}, // 第四列宽度为15
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15},
					{wch: 15}
				];
				worksheet['!cols'] = columnWidths;
				const wb = {
					Sheets: {'data': worksheet},
					SheetNames: ['data']
				};





				// 生成Excel的配置项
				const wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					type: 'binary'
				});
				// 创建二进制对象并创建url
				const blob = new Blob([this.s2ab(wbout)], {
					type: 'application/octet-stream'
				});
				const url = URL.createObjectURL(blob);
				// 创建a标签模拟点击进行下载
				const a = document.createElement('a');
				a.href = url;
				a.download = 'export.xlsx';
				document.body.appendChild(a);
				a.click();
				// 清除对象URL
				setTimeout(function() {
					URL.revokeObjectURL(url);
					document.body.removeChild(a);
				}, 0);
			},
			/**
			 * 字符串转二进制
			 */
			s2ab(s) {
				const buf = new ArrayBuffer(s.length);
				const view = new Uint8Array(buf);
				for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
				return buf;
			},
			/**
			 * 获取渠道数据
			 */
			GetChannelData() {
				// 检查是否允许获取渠道数据
				const allowChannel = sessionStorage.getItem('allowChannel');
				if (allowChannel === 'false') {
					return; // 不允许获取渠道，直接返回
				}
				// 获取渠道数据列表
				post('208', {
						channelName: ''
					})
					.then(response => {
						if (response.data.result == 0) {
							this.options = response.data.data;
						} else {
							this.$message.error('获取渠道失败:' + response.data.message);
						}
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '获取渠道失败');
					});
			},
			/**
			 * 页码切换事件
			 */
			handleCurrentChange(pageIndex) {
				this.GetData();
			},
			/**
			 * 每页大小切换事件
			 */
			handleSizeChange(size) {
				this.queryParams.pageSize = size;
			},
			/**
			 * 日期转yyyy-MM-dd
			 * @param {Object} today日期
			 */
			dataToString(today) {
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			/**
			 * 日期转HH:mm:ss
			 * @param {Object} today日期
			 */
			dataToString2(today) {
				let timeString = today.toLocaleTimeString('it-IT');
				return timeString;
			},
			/**
			 * 打开加载遮罩
			 */
			openLoading() {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.4)'
				});
				return loading;
			},
		},
		/**
		 * 加载完成事件
		 */
		mounted() {
			this.GetChannelData();
			this.GetData();
		},
		/**
		 * 计算属性
		 */
		computed: {
			/**
			 * 日期范围选择框
			 */
			dateRange: {
				get() {
					if (this.queryParams.beginTime == "" || this.queryParams.endTime == "") {
						const today = new Date();
						let year = today.getFullYear();
						let month = (today.getMonth() + 1).toString().padStart(2, '0');
						let day = today.getDate().toString().padStart(2, '0');
						this.queryParams.beginTime = `${year}-${month}-${day}`;
						this.queryParams.endTime = `${year}-${month}-${day}`;
					}
					return [new Date(Date.parse(this.queryParams.beginTime)), new Date(Date.parse(this.queryParams
						.endTime))];
				},
				set(value) {
					if (value == null) {
						const today = new Date();
						let year = today.getFullYear();
						let month = (today.getMonth() + 1).toString().padStart(2, '0');
						let day = today.getDate().toString().padStart(2, '0');
						this.queryParams.beginTime = `${year-1}-${month}-${day}`;
						this.queryParams.endTime = `${year}-${month}-${day}`;
					} else {
						this.queryParams.beginTime = this.dataToString(value[0]);
						this.queryParams.endTime = this.dataToString(value[1]);
					}
				}
			},
			/**
			 * 选择的渠道id
			 */
			SelectChannelId: {
				get() {
					if (this.queryParams.channelId == 0) {
						return '';
					} else {
						return this.queryParams.channelId;
					}
				},
				set(value) {
					if (value == '') {
						this.queryParams.channelId = 0;
					} else {
						this.queryParams.channelId = value;
					}
				}
			}
		}
	}
</script>

<style>
	.flex-box {
		display: flex;
		flex-direction: column;
	}

	.search-box {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}

	.searchItemName {
		width: 100px;
		text-align: right;
		display: inline-block;
	}

	.input-box {
		width: 200px;
	}

	.from-input {
		width: 300px;
	}
</style>